import { Container } from '@pixi/react'
import { Image } from '@slot-nx/core'
import { gameConfig } from '../config'
import { useGameStore } from '../domain/game/store/GameStore'

export const DesktopBackground = () => {
  // eslint-disable-next-line no-restricted-globals
  const device = screen
  const isShowBg = device.width > 1024
  const isFreeGame = useGameStore(state => state.isFreeGame)
  const fullScreen = isFreeGame ? 'image_webBackgroundBG' : 'image_webBackgroundMG'
  return (
    <Container visible={isShowBg} name="DesktopBackground" x={0} y={0}>
      <Image
        name="Background"
        image={fullScreen}
        width={3240}
        height={1920}
        x={gameConfig.resolution.width / 2}
        y={gameConfig.resolution.height / 2}
        anchor={[0.5, 0.5]}
      />
    </Container>
  )
}
